// Where an account lands after login, and where a refused route bounces to.
//
// Neoseum staff hold booking_staff_access and go to the calendar. An external
// partner login (Evoluon) holds only booking_report_external_runs and must
// never see the calendar, so its home is the Meldingen page. An account with
// neither gets a plain "no access" page instead of a redirect loop.
import type { PermissionKey } from '../types';

export const NO_ACCESS_PATH = '/geen-toegang';

export function homePath(can: (permission: PermissionKey) => boolean): string {
  if (can('booking_staff_access')) return '/calendar';
  if (can('booking_report_external_runs')) return '/meldingen';
  if (can('booking_manage_external_runs')) return '/runs';
  return NO_ACCESS_PATH;
}
